import { axios } from '@/services/api/axiosInstance'
import { endpoints } from '@/services/api/endpoints'
import { clearUserInfo, updateUserInfo } from '@/store/features/userSlice'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet } from 'react-router-dom'
import cookies from './cookies'
import { redirectToPlayApp } from './redirect'

const ProtectedRoute = () => {
  const dispatch = useDispatch()
  const accessToken = cookies.get('ai_tk')

  const fetchUser = () => {
    axios
      .get(endpoints.getUserData.url)
      .then((res) => {
        const userInfo = res.data?.data?.user_info
        
        if (!userInfo.is_onboarded) {
          redirectToPlayApp();
        } else if (!userInfo.access) {
          // User doesn't have creator access (redirect to play app)
          redirectToPlayApp()
        } else {
          dispatch(
            updateUserInfo({
              name: userInfo.name,
              email: userInfo.email,
              picture: userInfo.profile_image,
              userId: userInfo.user_id,
              lastLogin: userInfo?.['last-login'],
              role: userInfo.access_type,
              isOnboarded: userInfo.is_onboarded,
            })
          )
        }
      })
      .catch(() => {
        dispatch(clearUserInfo())
        cookies.remove('ai_tk')
        redirectToPlayApp()
      })
  }

  useEffect(() => {
    if (accessToken) {
      fetchUser()
    }
  }, [accessToken])

  if (!accessToken) {
    redirectToPlayApp()
    return null
  }
  return <Outlet />
}

export default ProtectedRoute
